/* eslint-disable @typescript-eslint/indent */
import { v4 as uuid } from 'uuid';
import axios from 'axios';
import { PizzaCharges, PizzaComplementsGroupIds } from '../enum/Pizza';
import { SessionStorageKeys } from '../enum/Storage';

import ICartItem from '../models/ICartItem';
import ICompany from '../models/ICompany';
import getPizzaCharge from './charge';
import { getSubdomain } from './subdomain';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 600000,
  headers: {
    'X-Tenant-Id': getSubdomain(),
  },
});

export const clearCartId = (): void => sessionStorage.removeItem(SessionStorageKeys.CART_ID);

export const getCartId = (): string => sessionStorage.getItem(SessionStorageKeys.CART_ID) || '';

export const getCartItemTotal = (company: ICompany, item: ICartItem): number => {
  const flavorsGroup = item.complementsGroups?.find(
    (group) => group?.id === PizzaComplementsGroupIds?.FLAVORS,
  );

  const pizzaCharge =
    company?.pizzaCharge === PizzaCharges.CUSTOM && company?.pizzaChargeCustom
      ? getPizzaCharge(company.pizzaChargeCustom, {
          FLAVORS: flavorsGroup?.complements?.length || 1,
        })
      : company?.pizzaCharge;

  return (
    (!item.pizzaCategoryId ? item.unitPrice : 0) * item.qty +
    item.complementsGroups.reduce((sum2, groups) => {
      if (groups?.id === PizzaComplementsGroupIds.FLAVORS && pizzaCharge === PizzaCharges.GREATER) {
        const greaterComplement = Math.max(
          ...(groups?.complements?.map((flavor) => flavor?.unitPrice || 0) || []),
        );

        return greaterComplement * (groups?.totalAmount || 0);
      }

      return (
        sum2 +
        groups.complements.reduce((sum3, complement) => {
          return sum3 + complement.amount * complement.unitPrice * item.qty;
        }, 0)
      );
    }, 0)
  );
};

export const generateCartId = (): void => {
  const cartId = getCartId() || uuid();
  api.interceptors.request.use((config) => {
    config.headers['X-Cart-Id'] = cartId;
    return config;
  });
  sessionStorage.setItem(SessionStorageKeys.CART_ID, cartId);
};
